import actionTypes from '../constants/action-types';

const dependencies = (state = [], action) => {
  if (action.type !== actionTypes.SET_DEPENDENCIES) {
    return state;
  }

  const { order, sources } = action.payload.dependencies;
  const sortedSources = sources
    .reduce((prev, curr) => {
      if (curr.dependencies) {
        return prev.concat([curr.id, ...curr.dependencies]);
      }
      return prev.concat(curr.id);
    }, [])
    .sort((a, b) => {
      if (order.indexOf(a) < 0) return +1;
      return order.indexOf(a) - order.indexOf(b);
    });

  return [...new Set(sortedSources)].map((srcId) => sources.find((src) => src.id === srcId));
};

export default dependencies;
